import axios from 'axios';
import {ICareer} from "../components/Careers";
import {ILeverAPIJobType} from "../types";

export const fetchLeverJobs = async (limit: number): Promise<ICareer[]> => {
  const username = process.env.NEXT_PUBLIC_LEVER_API_TOKEN;
  const password = ''; // needs to be blank
  const encodedCredentials = Buffer.from(`${username}:${password}`).toString('base64');

  try {
    const response = await axios.get(
        `https://api.lever.co/v1/postings?state=published&tag=byborg&limit=${limit}`,
        {
          headers: {
            Authorization: `Basic ${encodedCredentials}`,
          },
        }
    );

    return response.data.data.map((job: ILeverAPIJobType) => ({
      id: job.id,
      name: job.text,
      location: {
        city: job.categories.location,
      },
      department: {
        id: null,
        label: job.categories.department,
      },
    }));
  } catch (error) {
    console.warn('Error fetching Lever jobs:', error);
    return [];
  }
};
